import { Tabs } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CassaDiffRegistry from '../CassaDiffRegistry';
import PhysicalInventoryPanel from '../PhysicalInventoryPanel';
import CashHandoversPanel from './CashHandoversPanel';
import InventoryAtDatePanel from './InventoryAtDatePanel';
import SessionVerificationsPanel from './SessionVerificationsPanel';

const PHYSICAL_INVENTORY_GRID_HEIGHT = 'calc(100vh - 320px)';

/**
 * Control Room "Controlling" tab, the port of the legacy `ufrmControlling` form.
 *
 * Each sub-tab is mounted only while it is active, so its data is reloaded every
 * time it is opened, like the legacy `OnShow` handlers. The legacy "Amanari cu
 * aprobare" page is not repeated here: it is the Control Room's own
 * "Postponement Approvals" tab.
 */
const ControllingTab = () => {
    const { t } = useTranslation();
    const [activeKey, setActiveKey] = useState('cashHandovers');

    const renderWhenActive = (key: string, content: React.ReactNode) =>
        activeKey === key ? content : null;

    return (
        <Tabs
            activeKey={activeKey}
            onChange={setActiveKey}
            type="card"
            size="small"
            items={[
                {
                    key: 'cashHandovers',
                    label: t('controlRoom.controlling.tabs.cashHandovers'),
                    children: renderWhenActive('cashHandovers', <CashHandoversPanel />),
                },
                {
                    key: 'cashDifferences',
                    label: t('controlRoom.controlling.tabs.cashDifferences'),
                    children: renderWhenActive('cashDifferences', <CassaDiffRegistry />),
                },
                {
                    key: 'physicalInventory',
                    label: t('controlRoom.controlling.tabs.physicalInventory'),
                    children: renderWhenActive(
                        'physicalInventory',
                        <PhysicalInventoryPanel height={PHYSICAL_INVENTORY_GRID_HEIGHT} />,
                    ),
                },
                {
                    key: 'inventoryAtDate',
                    label: t('controlRoom.controlling.tabs.inventoryAtDate'),
                    children: renderWhenActive('inventoryAtDate', <InventoryAtDatePanel />),
                },
                {
                    key: 'sessionVerifications',
                    label: t('controlRoom.controlling.tabs.sessionVerifications'),
                    children: renderWhenActive(
                        'sessionVerifications',
                        <SessionVerificationsPanel />,
                    ),
                },
            ]}
        />
    );
};

export default ControllingTab;
